import React from 'react';

interface Age18IconProps {
    size?: number;
    className?: string;
}

const Age18Icon: React.FC<Age18IconProps> = ({ size = 16, className = '' }) => {
    return (
        <svg
            width={size}
            height={size}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            className={className}
        >
            {/* Kör */}
            <circle cx="12" cy="12" r="10" />
            {/* "18" szöveg */}
            <text
                x="12"
                y="16"
                textAnchor="middle"
                fontSize="10"
                fontWeight="bold"
                fill="currentColor"
            >
                18
            </text>
            {/* "+" szöveg */}
            <text
                x="18"
                y="13"
                textAnchor="middle"
                fontSize="8"
                fontWeight="bold"
                fill="currentColor"
            >
                +
            </text>
        </svg>
    );
};

export default Age18Icon;
